import React from 'react';
import { motion } from 'framer-motion';
import SulfurBurnerTwoCTA from './SulfurBurnerTwoCTA';

interface CropCTASectionProps {
  cropName: string;
  bgColor?: string;
  className?: string;
}

const CropCTASection: React.FC<CropCTASectionProps> = ({
  cropName,
  bgColor = 'bg-gradient-to-br from-gray-50 to-gray-100',
  className = ''
}) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className={`py-16 ${bgColor} ${className}`}
    >
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ready to Optimize Your {cropName} Water Management?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Start with pH + peak GPM. If you have a water/soil report, we'll tighten targets and reduce surprises.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          <SulfurBurnerTwoCTA layout="stacked" size="large" showPositioning={false} />
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            <strong>What to send (optional):</strong> Irrigation water alkalinity/bicarbonates (if you have it).
            If not, we'll start with pH + GPM and recommend what to test next.
          </p>
        </div>
      </div>
    </motion.section>
  );
};

export default CropCTASection;
